export default {
  content: {
    title: "预订",
    searchPlaceholder: "搜索候选人, 职位",
    searchPlaceholder2: "搜索候选人",
    searchPlaceholder3: "搜索预约人、展位主题",
    searchPlaceholder4: "搜索预约人",
    listOfBooking: "预约列表",
    noDataFound: "未找到数据",
    candidatesTracking: "候选人状态追踪",

    allInterviewDate: "所有面试日期与时间",
    selectInterviewStatus: "选择状态",
    showOnlyRegisteredTimes: "仅显示已登记时间",
    downloadBooking: "下载预约数据",
    bookerTracking: "追踪预约者",
  },

  tableHead: {
    interviewDate: "预约日期",
    interviewTime: "预约时间",
    candidateName: "候选人姓名",
    appointmentBooker: "预约人",
    jobPosition: "职位",
    status: "状态",

    category: "类别",
    applyDate: "申请日期",
  },

  preview: {
    detail: "详情",
    detailFund: "基金详情",
    edit: "编辑信息"
  },

  title: {
    createDetail: "创建详情",
    createDetailFund: "创建基金详情",
    business: "机构",
    subject: "主题",
    subjectFund: "基金主题",
    qualification: "资格详情",
    qualificationFund: "基金详情",
    jobDescription: "职位详情",
    jobDescriptionCondition: "condition",
  },

  rule: {
    selectBusiness: "请选择机构",
    enterSubject: "请输入主题",
    enterSubjectFund: "请输入基金主题",
    subjectRequired: "请输入主题",
    subjectRequiredFund: "请输入基金主题",
    noLeadingSpace: "开头不能有空格",
    singleSpaceOnly: "单词之间只能有一个空格",
    maxLength200: "最多可输入 200 个字符",

    changeStatusTo: "更改状态为",
    comment: "意见",
    enterComment: "请输入意见",
    recommendRequired: "请推荐相关机构",
    optional: "选填",
  },

  btn: {
    saveDraft: "保存草稿",
    post: "发布",
    postFund: "发布基金",
  },
};
